import { render, staticRenderFns } from "./Notice.vue?vue&type=template&id=332c3632"
import script from "./Notice.ts?vue&type=script&lang=ts&external"
export * from "./Notice.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports